export default [
  {
    name: "New Year's Day",
    date: "2026-01-01"
  },
  {
    name: "Islander Day",
    date: "2026-02-16",
    appliesTo: ['PE']
  },
  {
    name: "Louis Riel Day",
    date: "2026-02-16",
    appliesTo: ['MB']
  },
  {
    name: "Nova Scotia Heritage Day",
    date: "2026-02-16",
    appliesTo: ['NS']
  },
  {
    name: "Family Day",
    date: "2026-02-16",
    appliesTo: ['AB', 'BC', 'NB', 'ON', 'SK']
  },
  {
    name: "Good Friday",
    date: "2026-04-03"
  },
  {
    name: "Victoria Day",
    date: "2026-05-18",
    doesNotApplyTo: ['NB', 'NS', 'NL', 'PE', 'QC']
  },
  {
    name: "National Patriots' Day",
    date: "2026-05-18",
    appliesTo: ['QC']
  },
  {
    name: "National Indigenous Peoples Day",
    date: "2026-06-21",
    appliesTo: ['NT', 'YT']
  },
  {
    name: "Discovery Day (NL)",
    date: "2026-06-24",
    appliesTo: ['NL']
  },
  {
    name: "St. Jean Baptiste Day",
    date: "2026-06-24",
    appliesTo: ['QC']
  },
  {
    name: "Canada Day",
    date: "2026-07-01"
  },
  {
    name: "Nunavut Day",
    date: "2026-07-09",
    appliesTo: ['NU']
  },
  {
    name: "Civic Holiday",
    date: "2026-08-03",
    appliesTo: ['BC', 'SK', 'ON', 'NB', 'NU', 'NT']
  },
  {
    name: "Alberta Heritage Day",
    date: "2026-08-03",
    appliesTo: ['AB']
  },
  {
    name: "Discovery Day (YT)",
    date: "2026-08-17",
    appliesTo: ['YT']
  },
  {
    name: "Labour Day",
    date: "2026-09-07"
  },
  {
    name: "National Day for Truth and Reconciliation",
    date: "2026-09-30",
    appliesTo: ['BC', 'MB', 'YT', 'PE', 'NT']
  },
  {
    name: "Thanksgiving",
    date: "2026-10-12",
    doesNotApplyTo: ['NB', 'NS', 'NL', 'PE']
  },
  {
    name: "Remembrance Day",
    date: "2026-11-11",
    doesNotApplyTo: ['MB', 'ON', 'QC', 'NS']
  },
  {
    name: "Christmas Day",
    date: "2026-12-25"
  },
  {
    name: "Boxing Day",
    date: "2026-12-26",
    appliesTo: ['ON']
  }
];
